import { Drawer } from '../../common';
import { useDrawer } from '../../../hooks';
import { ReactNode } from 'react';

interface DealerLocatorFiltersDrawerProps {
  storeDetailsDrawer: ReturnType<typeof useDrawer>;
  children: ReactNode;
}

export const DealerLocatorStoreDetailsDrawer = ({
  storeDetailsDrawer,
  children
}: DealerLocatorFiltersDrawerProps) => {
  return (
    <Drawer
      className="u-color--Black"
      hideCloseButton={true}
      {...storeDetailsDrawer.drawerProps}
    >
      {children}
    </Drawer>
  );
};
